export default __webpack_public_path__ + "static/media/027-vegetables.07036b59.svg";